<template>
  <div class="no-data">
    <div class="no-data__icon">
      <slot name="icon"></slot>
    </div>
    <div class="no-data__message">
      <slot name="message"></slot>
    </div>
    <div class="no-data__sub-message">
      <slot name="sub-message"></slot>
    </div>
    <div class="no-data__button">
      <slot name="button"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icon: String,
    message: String,
  },
};
</script>

<style scoped lang="scss">
@import "~styles/shared.scss";

.no-data {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 25px 10px;
  text-align: center;
}

.no-data__icon {
  i {
    font-size: 64px;
    color: $gray;
  }

  margin-bottom: 10px;
}

.no-data__message {
  font-size: 24px;
  font-weight: bold;
  font-family: 'MuseoSans-500';
  opacity: 0.9;
}

.no-data__button {
  margin-top: 20px;
}

.no-data__button a, .no-data__button button {
  text-decoration: none;
  color: $white;
  background: $primary;
  font-family: MuseoSans-900;
  text-align: center;
  border-radius: 24px;
  padding: 10px 20px;
}
</style>





// WEBPACK FOOTER //
// src/components/shared/NoDataMessage.vue